const yearsUntilGraduation = graduationYear => {
  const currentYear = new Date().getFullYear()

  return graduationYear - currentYear
}
const calculateCurrentGradeLevelId = (graduationYear, gradeLevels) => {
  const gradeCalculation = yearsUntilGraduation(graduationYear)
  let gradeLevelId = ''
  const grade = gradeLevels.grades

  switch (gradeCalculation) {
    case 13:
      gradeLevelId = grade[0] // kindergarten
      break
    case 12:
      gradeLevelId = grade[1] // first grade
      break
    case 11:
      gradeLevelId = grade[2] // second grade
      break
    case 10:
      gradeLevelId = grade[3] // third grade
      break
    case 9:
      gradeLevelId = grade[4] // fourth grade
      break
    case 8:
      gradeLevelId = grade[5] // fifth grade
      break
    default:
      gradeLevelId = null // any grade beyond fifth grade is not an elementary student
  }

  return gradeLevelId
}

export { calculateCurrentGradeLevelId }
